module.exports = __webpack_public_path__ + "static/media/icon-image.6213a089.svg";